import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const RECOGNIZE_RESEARCH_CONCURRENCY = 25;

export const runRecognizeOrders = unaryRpc({
  name: "runRecognizeOrders",
  input: z.object({
    teamId: zExt.objectId(),
    recentCount: z.number().int().min(1).max(10_000).optional(),
  }),
  output: z.object({
    started: z.boolean(),
    workflowId: z.string().nullable(),
    message: z.string().optional(),
  }),
});
